import { SIGNUP_FORM_FIELDS } from './forms'

export const AUTH_MODALS_INFO = {
  PersonalData: {
    field: SIGNUP_FORM_FIELDS.authPersonalData.value,
    text: '',
    title: 'Tratamiento de datos personales',
  },
  TermsAndConditions: {
    field: SIGNUP_FORM_FIELDS.authTermsAndConditions.value,
    text: '',
    title: 'Términos y Condiciones',
  },
}
